/**=========================================================
 * Module: fileversions.js
 * FileVersions Controller
 =========================================================*/

 App.controller('FileVersionsController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'ngDialog',
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, ngDialog) {
   "use strict";
   
   
     
 }
 ]);